import axios, { CancelTokenSource } from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export default class DigServices {
  getSourceAdaptors(obj: any, tokenSource?: CancelTokenSource) {
    return axios.get(GetBackendUrlForGlobalFunctions() + `dig/adaptors`, {
      cancelToken: tokenSource?.token,
      params: obj,
    });
  }
  AddSourceAdaptor(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      GetBackendUrlForGlobalFunctions() + `dig/adaptors/add`,
      obj,
      { headers }
    );
  }

  EditSourceAdaptor(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      GetBackendUrlForGlobalFunctions() + `dig/adaptors/update`,
      obj,
      { headers }
    );
  }

  DeleteSourceAdaptor(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      GetBackendUrlForGlobalFunctions() + `dig/adaptors/delete`,
      obj,
      { headers }
    );
  }
}
